import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const Container = styled(FlexColumn)`
    overflow: hidden;
`;

export const Title = styled(FlexRow)`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])};
    margin-bottom: 8px;
    align-items: center;
    gap: 8px;

    .icon {
        display: flex;
    }
`;

export const SubTitle = styled(FlexRow)`
    ${setFontVariant("chip1", colorsPalettes.carbon[400])};
    margin-bottom: 20px;
    max-width: 308px;
`;

export const Body = styled(FlexColumn)`
    flex: 1;
    overflow-y: auto;
    padding-top: 16px;
    gap: 16px;
`;

export const Footer = styled(FlexRow)`
    gap: 4px;
    margin-bottom: 16px;
    padding-right: 16px;
    justify-content: end;
`;

export const Content = styled(FlexColumn)`
    padding: 20px 24px 24px;
    overflow: hidden;
`;
